/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { OperatorDetailsDto } from '../../api/operators/operatorsClient.typings';
import {
    OperatorAccHomePageActionType,
    OperatorAccHomePageActions,
} from '../../actions/OperatorAcc/OperatorAccHomeActions';
import { OperatorCashBoxesStats } from '../../api/cashBoxes/cashBoxesClient.typings';

export interface OperatorAccHomeState {
    operatorDetails: OperatorDetailsDto;
    operatorCashBoxesStats: OperatorCashBoxesStats;
    isLoadingDetails: boolean;
    isLoadingCashBoxesStats: boolean;
}

const initialState: OperatorAccHomeState = {
    operatorDetails: null,
    operatorCashBoxesStats: null,
    isLoadingDetails: false,
    isLoadingCashBoxesStats: false,
};

function operatorAccHomeReducer(
    state: OperatorAccHomeState = initialState,
    action: OperatorAccHomePageActions,
): OperatorAccHomeState {
    switch (action.type) {
        case OperatorAccHomePageActionType.OPEN_OPERATOR_ACC_HOME_PAGE:
            return {
                ...state,
                isLoadingDetails: true,
                isLoadingCashBoxesStats: true,
            };

        case OperatorAccHomePageActionType.FETCH_OPERATOR_ACC_DETAILS_SUCCESS:
            return {
                ...state,
                isLoadingDetails: false,
                operatorDetails: action.payload,
            };

        case OperatorAccHomePageActionType.FETCH_OPERATOR_ACC_CASHBOXES_STATS_SUCCESS:
            return {
                ...state,
                isLoadingCashBoxesStats: false,
                operatorCashBoxesStats: action.payload,
            };

        case OperatorAccHomePageActionType.FETCH_OPERATOR_ACC_HOME_DATA_ERROR:
            return {
                ...state,
                isLoadingDetails: false,
                isLoadingCashBoxesStats: false,
            };

        case OperatorAccHomePageActionType.EXIT_OPERATOR_ACC_HOME_PAGE:
            return {
                ...state,
                operatorDetails: null,
                operatorCashBoxesStats: null,
            };

        default:
            return state;
    }
}

export default operatorAccHomeReducer;
